// extracted by mini-css-extract-plugin
module.exports = {"mediaWrapper":"Story_mediaWrapper__Qc_Fl","image":"Story_image__DBY4t","video":"Story_video__rAPWj"};